import { NgModule } from "@angular/core";
import { ConfirmComponent } from "./confirm.component";
import { CommonModule } from "@angular/common";
import { DialogModule } from "primeng/dialog";
import { ConfirmService } from "./confirm.service";
import { DialogService } from "primeng/dynamicdialog";
import { ButtonModule } from "primeng/button";

@NgModule({
  declarations: [ConfirmComponent],
  imports: [CommonModule, DialogModule, ButtonModule],
  exports: [ConfirmComponent, DialogModule],
  providers: [DialogService, ConfirmService]
})
export class ConfirmModule { }